import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDetailsUrl, getTitle, getSubtitle } from "../../util/mediaUtil";
import { Checkbox } from "react-toolbox/lib/checkbox";
import { Link } from "react-toolbox/lib/link";
import { ProgressBar } from "react-toolbox/lib/progress_bar";
import MediaAvatar from "components/MediaAvatar";
import MediaIcon from "components/MediaIcon";
import MediaLink from "../../application/components/MediaLink";
import { showRemoveModulesDrawer } from "browse-media/redux/browseMediaActions";
import {
  fetchVocabulary,
  showDrawer as showEditMediaDrawer,
} from "edit-media/redux/editMediaActions";
import styles from "browse-media/components/BrowseMediaSearchResultsRow.css";
import Button from "@material-ui/core/Button";
import EditIcon from "@material-ui/icons/Edit";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import {
  SHOW_VIEWER,
  getViewerTypeForMedia,
} from "media-viewer/mediaViewerRedux";
import { notBlank } from "../../util/ext";

const getParentModuleCountLabel = media =>
  media.parentModules ? `${media.parentModules.length}` : "0";

const isSyncing = (media, syncingMediaIds) =>
  syncingMediaIds.includes(media.id);

const BrowseMediaSearchResultsRow = ({ media, selected, onSelect }) => {
  const syncingMediaIds = useSelector(
    state => state.browseMedia.syncingMediaIds,
  );
  const dispatch = useDispatch();
  const viewerType = getViewerTypeForMedia(media);

  return (
    <li
      className={selected ? styles.listItemSelected : styles.listItem}
      onClick={e => {
        e.stopPropagation();
        onSelect(!selected, media.id);
      }}
    >
      <Checkbox
        theme={styles}
        checked={selected}
        onChange={(value, e) => e.stopPropagation()}
      />
      <div className={styles.titleColumn}>
        <div className={styles.avatarContainer}>
          <MediaAvatar media={media}>
            <MediaIcon className={styles.mediaIcon} media={media} />
          </MediaAvatar>
        </div>
        <div className={styles.textContainer}>
          <span className={styles.itemTitle}>{getTitle(media)}</span>

          {media.mediaType === "collection" && notBlank(media.anthology) ? (
            <span className={styles.itemSubTitle}>
              <span>Found in:</span>
              &nbsp;
              <Link
                className={styles.anthologyLink}
                href={getDetailsUrl(media.anthology)}
                label={getTitle(media.anthology)}
                target="_blank"
                onClick={e => {
                  e.stopPropagation();
                }}
              />
            </span>
          ) : (
            <span className={styles.itemSubTitle}>{getSubtitle(media)}</span>
          )}
        </div>
      </div>
      <div className={styles.modulesColumn}>
        {isSyncing(media, syncingMediaIds) ? (
          <ProgressBar theme={styles} type="circular" mode="indeterminate" />
        ) : (
          <Link
            className={styles.modulesLink}
            label={getParentModuleCountLabel(media)}
            onClick={e => {
              e.stopPropagation();

              if (media.parentModules && media.parentModules.length > 0) {
                dispatch(showRemoveModulesDrawer(media));
              }
            }}
          />
        )}
      </div>
      <div className={styles.actionColumn}>
        {media.mediaType === "content" ? (
          <>
            <Button
              startIcon={<EditIcon />}
              onClick={e => {
                e.stopPropagation();
                dispatch(fetchVocabulary());
                dispatch(showEditMediaDrawer(media));
              }}
            >
              Edit
            </Button>

            {viewerType && (
              <Button
                startIcon={<OpenInNewIcon />}
                onClick={e => {
                  e.stopPropagation();
                  dispatch({ type: SHOW_VIEWER, media });
                }}
              >
                Open
              </Button>
            )}
          </>
        ) : (
          notBlank(media.anthology) && (
            <MediaLink media={media} label="Explore" />
          )
        )}
      </div>
    </li>
  );
};

export default BrowseMediaSearchResultsRow;
